document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('kudo-checkout-form');
    if (!form) return; // section not on this page

    var ajaxUrl      = wc_checkout_params.ajax_url;
    var updateNonce  = wc_checkout_params.update_order_review_nonce;
    var couponNonce  = wc_checkout_params.apply_coupon_nonce;
    var checkoutUrl  = wc_checkout_params.checkout_url;

    // ========== COUNTRY → STATE FIELD ==========
    var countrySelect  = document.getElementById('billing_country');
    var stateFieldWrap = document.getElementById('kudo-state-field-wrap');
    var states         = window.kudoCheckoutStates || {};

    function renderStateField() {
        if (!countrySelect || !stateFieldWrap) return;

        var countryStates = states[countrySelect.value];
        var currentValue  = (document.getElementById('billing_state') || {}).value || '';
        var label         = '<label for="billing_state">Province</label>';

        if (countryStates && Object.keys(countryStates).length) {
            var options = '<option value="">Select province</option>';
            Object.keys(countryStates).forEach(function (code) {
                var selected = code === currentValue ? ' selected' : '';
                options += '<option value="' + code + '"' + selected + '>' + countryStates[code] + '</option>';
            });
            stateFieldWrap.innerHTML = label + '<select id="billing_state" name="billing_state">' + options + '</select>';
        } else {
            stateFieldWrap.innerHTML = label + '<input type="text" id="billing_state" name="billing_state" placeholder="Province" value="' + currentValue + '">';
        }
    }

    if (countrySelect) {
        countrySelect.addEventListener('change', renderStateField);
        renderStateField();
    }

    // ========== PAYMENT METHOD SELECTION ==========
    var paymentInput       = document.getElementById('kudo-payment-method');
    var paymentOptionInput = document.getElementById('kudo-paymid-method-option');
    var paymentCards       = document.querySelectorAll('.woo-checkout__payment-card');

    paymentCards.forEach(function (card) {
        if (card.classList.contains('is-disabled')) return;

        card.addEventListener('click', function () {
            paymentCards.forEach(function (c) { c.classList.remove('is-selected'); });
            card.classList.add('is-selected');
            paymentInput.value = card.dataset.method;
            if (paymentOptionInput) paymentOptionInput.value = card.dataset.option || 'card';
        });
    });

    // ========== ADD-ON SELECTION (single-select toggle, no "None" card) ==========
    var addonCards = document.querySelectorAll('.woo-checkout__addon-card');
    var addonRequestInFlight = false;

    addonCards.forEach(function (card) {
        card.addEventListener('click', function () {
            if (addonRequestInFlight) return;

            var wasSelected = card.classList.contains('is-selected');
            var addonId     = wasSelected ? 'none' : card.dataset.addonId;

            addonCards.forEach(function (c) { c.classList.remove('is-selected'); });
            if (!wasSelected) card.classList.add('is-selected');

            updateCartAddon(addonId);
        });
    });

    function updateCartAddon(addonId) {
        addonRequestInFlight = true;

        var section = document.querySelector('.woo-checkout__addon-grid');
        if (section) section.style.opacity = '0.5';

        var formData = new FormData();
        formData.append('action', 'update_cart_addon');
        formData.append('addon_id', addonId);
        formData.append('security', updateNonce);

        fetch(ajaxUrl, { method: 'POST', body: formData, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (data.success) {
                    // Swap in the recalculated totals in place — no reload, so
                    // whatever the customer already typed into the form stays put.
                    applyTotals(data.data);
                    if (section) section.style.opacity = '1';
                } else {
                    alert('Error updating add-on. Please try again.');
                    if (section) section.style.opacity = '1';
                }
                addonRequestInFlight = false;
            })
            .catch(function () {
                alert('Error updating add-on. Please try again.');
                if (section) section.style.opacity = '1';
                addonRequestInFlight = false;
            });
    }

    function applyTotals(data) {
        var totals   = document.getElementById('kudo-checkout-totals');
        var totalRow = document.getElementById('kudo-checkout-total-row');
        if (totals && data && data.totals_html !== undefined) totals.innerHTML = data.totals_html;
        if (totalRow && data && data.total_row_html !== undefined) totalRow.innerHTML = data.total_row_html;
    }

    // ========== COUPON ==========
    var applyCouponBtn = document.querySelector('.woo-checkout__apply-coupon');

    if (applyCouponBtn) {
        applyCouponBtn.addEventListener('click', applyCoupon);
    }

    function applyCoupon() {
        var couponInput = document.getElementById('kudo-coupon-code');
        var messagesDiv = document.querySelector('.woo-checkout__coupon-messages');
        var couponCode  = couponInput.value.trim();

        if (messagesDiv) messagesDiv.innerHTML = '';

        if (!couponCode) {
            if (messagesDiv) messagesDiv.innerHTML = '<div class="woocommerce-error">Please enter a coupon code.</div>';
            return;
        }

        applyCouponBtn.disabled = true;
        applyCouponBtn.textContent = 'Applying...';

        var formData = new FormData();
        formData.append('action', 'apply_coupon_checkout');
        formData.append('coupon_code', couponCode);
        formData.append('security', couponNonce);
        // Coupons limited to an email (e.g. spin-the-wheel rewards) are checked against it
        var emailInput = document.getElementById('billing_email');
        if (emailInput) formData.append('billing_email', emailInput.value.trim());

        fetch(ajaxUrl, { method: 'POST', body: formData, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (data.success) {
                    // No success message shown, and no reload — just swap in the
                    // recalculated totals so anything already typed into the form
                    // (email, billing info) stays put.
                    applyTotals(data.data);
                    couponInput.value = '';
                } else {
                    if (messagesDiv) messagesDiv.innerHTML = '<div class="woocommerce-error">' + data.data.message + '</div>';
                }
                applyCouponBtn.disabled = false;
                applyCouponBtn.textContent = 'Apply';
            })
            .catch(function () {
                if (messagesDiv) messagesDiv.innerHTML = '<div class="woocommerce-error">An error occurred. Please try again.</div>';
                applyCouponBtn.disabled = false;
                applyCouponBtn.textContent = 'Apply';
            });
    }

    // Remove-coupon links are now built LP-aware server-side (kudo_render_checkout_totals()
    // in inc/woo-commerce.php), so they navigate correctly with a plain <a href> — no
    // JS needed here. (Previously this tried to patch an `ib` param back onto the URL
    // from window.location.search, but that's never present in the visible address bar
    // on a rewritten LP URL like /execution-room/checkout/, so it silently did nothing.)

    // Re-render totals from the server — after a failed Place order, as
    // WooCommerce may have removed a coupon (e.g. email didn't match).
    function refreshTotals() {
        var formData = new FormData();
        formData.append('action', 'kudo_checkout_totals');
        formData.append('security', updateNonce);

        fetch(ajaxUrl, { method: 'POST', body: formData, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (data) { if (data.success) applyTotals(data.data); })
            .catch(function () {});
    }

    // ========== CHECKOUT SUBMIT ==========
    form.addEventListener('submit', function (e) {
        e.preventDefault();

        var errorBox = document.getElementById('kudo-checkout-errors');
        var payBtn    = document.querySelector('.woo-checkout__pay-btn');

        if (errorBox) {
            errorBox.hidden = true;
            errorBox.innerHTML = '';
        }
        if (payBtn) {
            payBtn.disabled = true;
            payBtn.dataset.originalText = payBtn.dataset.originalText || payBtn.textContent;
            payBtn.textContent = 'Processing...';
        }

        var formData = new FormData(form);

        fetch(checkoutUrl, {
            method: 'POST',
            body: new URLSearchParams(formData),
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (data.result === 'success' && data.redirect) {
                    window.location = data.redirect;
                    return;
                }

                if (errorBox) {
                    errorBox.innerHTML = data.messages || 'Something went wrong. Please check your details and try again.';
                    errorBox.hidden = false;
                    errorBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                refreshTotals();
                if (payBtn) {
                    payBtn.disabled = false;
                    payBtn.textContent = payBtn.dataset.originalText;
                }
            })
            .catch(function () {
                if (errorBox) {
                    errorBox.innerHTML = 'Something went wrong. Please check your connection and try again.';
                    errorBox.hidden = false;
                }
                if (payBtn) {
                    payBtn.disabled = false;
                    payBtn.textContent = payBtn.dataset.originalText;
                }
            });
    });
});
